<div class="medication-details-container">
    <div class="top-row">
        <p-breadcrumb [model]="breadcrumbItems" (onItemClick)="onBreadcrumbClick($event)"></p-breadcrumb>
        <div class="top-actions" *ngIf="canEdit">
            <p-button label="Cancel" [outlined]="true" styleClass="cancel-btn" (onClick)="cancel()"></p-button>
            <p-button label="Save" styleClass="save-btn" [disabled]="!isDirty" (onClick)="save()"></p-button>
        </div>
        <div class="top-actions" *ngIf="!canEdit">
            <p-button label="Back" [outlined]="true" styleClass="cancel-btn" (onClick)="cancel()"></p-button>
        </div>
    </div>

    <h2 class="page-title">Item Group Details</h2>

    <h3 class="item-group-name">Item: {{ medication?.medGroupName }}</h3>

    <!-- Diversion Weight -->
    <h3 class="section-title">Diversion Weight</h3>
    <div [class.readonly-overlay]="!canEdit">
        <app-weight-selector [selectedWeight]="selectedWeight" [disabled]="!canEdit" (weightChange)="onWeightChange($event)"></app-weight-selector>
    </div>

    <ng-container *ngIf="assayManagementEnabled">
        <!-- Assay Tracking -->
        <h3 class="section-title">Assay Tracking</h3>
        <div class="assay-section" [class.readonly-overlay]="!canEdit">
            <div class="assay-info">
                <p>Include this item in the waste assay testing program. Typically used for injectables.</p>
            </div>
            <p-toggleSwitch [(ngModel)]="assayTrackable" [disabled]="!canEdit"></p-toggleSwitch>
        </div>
    </ng-container>

    <!-- Mapped Items -->
    <h3 class="section-title">Mapped Items</h3>
    <div class="mapped-table-container">
        <p-table 
            [value]="mappedItems" 
            [paginator]="true"
            [rows]="10" 
            [scrollable]="true" 
            styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
                <tr>
                    <th>Item Description</th>
                    <th style="text-align: center">Item ID</th>
                    <th style="text-align: center">Source</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>{{ item.description }}</td>
                    <td style="text-align: center">{{ item.medId }}</td>
                    <td style="text-align: center">
                        <span [class]="item.source === 'ADC' ? 'source-adc' : 'source-ehr'">{{ item.source }}</span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="3" class="empty-table-message">No mapped items</td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <!-- Confirmation Dialog -->
    <p-dialog header="Confirm Change" [(visible)]="showConfirmDialog" [modal]="true" [closable]="true" [style]="{width: '32rem'}" styleClass="confirm-dialog">
        <p class="dialog-body">
            You are saving changes to <strong>{{ medication?.medGroupName }}</strong>.
            This will update diversion weight<ng-container *ngIf="assayManagementEnabled"> and/or assay tracking settings</ng-container>. Are you sure you want to confirm?
        </p>
        <ng-template pTemplate="footer">
            <p-button label="No" [outlined]="true" styleClass="dialog-btn-no" (onClick)="cancelConfirm()"></p-button>
            <p-button label="Yes" styleClass="dialog-btn-yes" (onClick)="confirmSave()"></p-button>
        </ng-template>
    </p-dialog>
</div>

<p-toast></p-toast>
